export default __webpack_public_path__ + "static/media/icon-19.25250f14.png";